import HelpdeskForm from "../components/HelpdeskForm";
import React from "react";
import Meta from "./../components/Meta";
import HeroSection3 from "./../components/HeroSection";

function HelpdeskPage(props) {
    return (
        <>
        <br>
        </br>
        <Meta title="Helpdesk" />
        <HelpdeskForm
            color="secondary"
            size="medium"
            backgroundImage="/halftone-1696560535.svg"
            backgroundImageOpacity={1}
            title="PDS Helpdesk"
            subtitle="Submit a support ticket to the PDS team! We will respond promptly via email."
            buttonText=""
            buttonColor="primary"
            buttonInverted={false}
            showNameField={true}
            />
        </>
    );
}

export default HelpdeskPage;